import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const katanaSettings = defineIntegrationSettings({
  fields: { restockLocationId: z.number().int() },
  secrets: {
    accessToken: z.string().trim().min(1, "Access token is required"),
  },
  connectOnly: {},
  computed: {},
});
